import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import { teacherDeleteUser, teacherFetchUserList, teacherInsertNewStudent, teacherUpdateUser } from '../../services2/users.service';
import { teacherFetchResearchTaskRecords } from '../../services2/researchTaskRecords.service';
import * as XLSX from 'xlsx';
import { questionnaire_background } from './components/Questionnaire_background';
import { questionnaire_A1 } from './components/Questionnaire_A1_data';
import { questionnaire_A2 } from './components/Questionnaire_A2_data';
import { questionnaire_B1 } from './components/Questionnaire_B1_data';
import { questionnaire_B2 } from './components/Questionnaire_B2_data';

function Component(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setisLoading] = useState(false)

  const [students, setStudents] = useState([])
  const fetchStudents = async () => {
    let result = await teacherFetchUserList(props.token.token, { type: 'student' }, { limit: 9999, sort: { name: 1 } });
    if (result.result) {
      setStudents(result.result || [])
    } else {
      console.log('Fetch data error')
    }
  }

  const refresh = async () => {
    if (isLoading) return
    setisLoading(true)
    await fetchStudents()
    setisLoading(false)
  }

  useEffect(() => {
    refresh()
  }, [id])

  const handleSelectStudent = (id) => {
    setStudents(prev => prev.map(item => item._id === id ? { ...item, isSelected: !item.isSelected } : item))
  }


  const [filterName, setfilterName] = useState('')
  const [filterClass, setfilterClass] = useState('')
  const [filterGroup, setfilterGroup] = useState('')
  const filter = (list) => {
    if (!list) return []
    let result = list.filter(item => {
      if (filterName && item.name.indexOf(filterName) === -1) return false
      if (filterClass && item.class.indexOf(filterClass) === -1) return false
      if (filterGroup && item.group !== filterGroup) return false
      return true
    })
    return result
  }

  const handleDownloadData = async () => {
    setisLoading(true)
    const sheet1 = await FormatDemographicSheet()
    const sheet2 = await FormatQuestionnaireASheet()
    const sheet3 = await FormatQuestionnaireBSheet()
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, sheet1, 'demographic')
    XLSX.utils.book_append_sheet(workbook, sheet2, '問卷 A1 A2')
    XLSX.utils.book_append_sheet(workbook, sheet3, '問卷 B1 B2')
    XLSX.writeFile(workbook, 'students_data.xlsx')
    setisLoading(false)
  }

  const FormatDemographicSheet = async () => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組']
    for (let section of questionnaire_background.sections) {
      for (let question of section) {
        if (question.type === 'table') {
          for (let row of question.questions || []) {
            headers.push(question.title + ' ' + row.question)
          }
        } else {
          headers.push(question.question)
        }
      }
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected) {
        let demographicData = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 0, taskId: '100' }, { limit: 1 });
        let demographicArray = []
        if (demographicData.result && demographicData.result?.[0]) {
          let data = demographicData.result?.[0]?.data || {}

          for (let sectionIndex in questionnaire_background.sections) {
            let section = questionnaire_background.sections[sectionIndex]
            for (let questionIndex in section) {
              let question = section?.[questionIndex] || {}

              if (question.type === 'table') {
                for (let rowIndex in question.questions || []) {
                  let row = question.questions[rowIndex] || {}
                  demographicArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
                }
              } else if (question.type === 'single-choice') {
                if (data?.sections?.[sectionIndex]?.[questionIndex]?.answer?.includes('其他（請寫出）')) {
                  demographicArray.push((data?.sections?.[sectionIndex]?.[questionIndex]?.answer + ": " + data?.sections?.[sectionIndex]?.[questionIndex]?.answerDetail || ''))
                } else {
                  demographicArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.answer || '')
                }
              } else {
                demographicArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.answer || '')
              }
            }

          }
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...demographicArray])
      }
    }

    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }
  const FormatQuestionnaireASheet = async () => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組']
    for (let section of questionnaire_A1.sections) {
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
    }
    for (let section of questionnaire_A2.sections) {
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected && ['1', '3', '5', '7', '9', '11'].includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 1, taskId: '100' }, { limit: 1 });
        let dataA2 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 7, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && ['1', '3', '5', '7', '9', '11'].includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          console.log(data)

          for (let sectionIndex in questionnaire_A1.sections) {
            let section = questionnaire_A1.sections[sectionIndex]
            for (let questionIndex in section) {
              let question = section?.[questionIndex] || {}

              for (let rowIndex in question.questions || []) {
                dataArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
              }
            }
          }
          if (dataA2.result && dataA2.result?.[0] && ['1', '3', '5', '7', '9', '11'].includes(dataA2.result?.[0].group)) {
            let data2 = dataA2.result?.[0]?.data || {}
            for (let sectionIndex in questionnaire_A2.sections) {
              let section = questionnaire_A2.sections[sectionIndex]
              for (let questionIndex in section) {
                let question = section?.[questionIndex] || {}

                for (let rowIndex in question.questions || []) {
                  dataArray.push(data2?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
                }
              }
            }
          }
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray])
      }

    }
    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }
  const FormatQuestionnaireBSheet = async () => {
    const headers = ['id', '學生姓名', '班級', '電郵', '分組']
    for (let section of questionnaire_B1.sections) {
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
    }
    for (let section of questionnaire_B2.sections) {
      for (let question of section) {
        for (let row of question.questions || []) {
          headers.push(question.title + ' ' + row.question)
        }
      }
    }
    const arrayToExport = [
      headers
    ]
    for (let student of filter(students)) {
      if (student.isSelected && ['2', '4', '6', '8', '10', '12'].includes(student.group)) {
        let dataA1 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 1, taskId: '100' }, { limit: 1 });
        let dataA2 = await teacherFetchResearchTaskRecords(props.token.token, { studentId: student._id, session: 7, taskId: '100' }, { limit: 1 });
        let dataArray = []
        if (dataA1.result && dataA1.result?.[0] && ['2', '4', '6', '8', '10', '12'].includes(dataA1.result?.[0].group)) {
          let data = dataA1.result?.[0]?.data || {}
          console.log(data)

          for (let sectionIndex in questionnaire_B1.sections) {
            let section = questionnaire_B1.sections[sectionIndex]
            for (let questionIndex in section) {
              let question = section?.[questionIndex] || {}

              for (let rowIndex in question.questions || []) {
                dataArray.push(data?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
              }
            }
          }
          if (dataA2.result && dataA2.result?.[0] && ['2', '4', '6', '8', '10', '12'].includes(dataA2.result?.[0].group)) {
            let data2 = dataA2.result?.[0]?.data || {}
            for (let sectionIndex in questionnaire_B2.sections) {
              let section = questionnaire_B2.sections[sectionIndex]
              for (let questionIndex in section) {
                let question = section?.[questionIndex] || {}

                for (let rowIndex in question.questions || []) {
                  dataArray.push(data2?.sections?.[sectionIndex]?.[questionIndex]?.questions?.[rowIndex]?.answer || '')
                }
              }
            }
          }
        }
        arrayToExport.push([student._id, student.name, student.class, student.username, student.group, ...dataArray])
      }

    }
    const sheet1 = XLSX.utils.aoa_to_sheet(arrayToExport)
    return sheet1
  }

  const handleSelectAll = (e) => {
    const checked = e.target.checked
    setStudents(prevStudents => prevStudents.map(student => ({ ...student, isSelected: checked })))
  }

  return (
    <div className='relative h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px] text-[16px] text-[black]  min-h-[500px] px-[16px]'>

      <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap justify-between items-center'>
        <div className='font-[700] text-[20px]'>學生數據</div>

      </div>

      {/*serach bar*/}
      <div className='w-full flex flex-row gap-[8px] items-center flex flex-wrap gap-[16px]'>
        <div className='font-[400]'>搜尋學生姓名:</div>
        <input value={filterName} onChange={(e) => { setfilterName(e.target.value) }} placeholder='學生姓名' className='rounded-[7px] px-[8px] py-[4px] font-[400] flex-1 max-w-[200px]' style={{ border: '1px solid black' }} />

        <div className='font-[400]'>搜尋班級:</div>
        <input value={filterClass} onChange={(e) => { setfilterClass(e.target.value) }} placeholder='班級' className='rounded-[7px] px-[8px] py-[4px] font-[400] flex-1 max-w-[200px]' style={{ border: '1px solid black' }} />

        <div className='font-[400]'>搜尋分組:</div>
        <input value={filterGroup} onChange={(e) => { setfilterGroup(e.target.value) }} placeholder='分組' className='rounded-[7px] px-[8px] py-[4px] font-[400] flex-1 max-w-[200px]' style={{ border: '1px solid black' }} />
        <div className='flex-1 flex flex-row justify-end'>
          <button onClick={handleDownloadData} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#63BBD1]' style={{ background: 'linear-gradient(90deg, #178E95 0%, #07162F 100%)' }}>
            下載 Pilot Test 學生數據
          </button>
        </div>

      </div>

      {/*list of students*/}
      <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{ overflowY: 'auto' }}>
        <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
          <div className='flex-1 flex flex-row'>
            <input type='checkbox' onChange={handleSelectAll} />
            學生姓名
          </div>
          {/* <div className='flex-1'>性別</div> */}
          <div className='flex-1'>班級</div>
          <div className='flex-1'>電郵</div>
          <div className='flex-[.5]'>分組</div>
          <div className='flex-1'>狀態</div>
          <div className='w-[64px]'></div>
        </div>
        {filter(students)?.map((item, index) =>
          <div key={item?._id || index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
            <div className='flex-1 flex flex-row gap-[4px] items-center'>
              <input type='checkbox' checked={item?.isSelected} onChange={() => handleSelectStudent(item?._id)} />
              {item?.name}
            </div>
            {/* <div className='flex-1'>{item?.gender}</div> */}
            <div className='flex-1'>{item?.class}</div>
            <div className='flex-1'>{item?.username}</div>
            <div className='flex-[.5]'>{item?.group}</div>
            <div className='flex-1 flex flex-row'>
              {item.status === 'active' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>Active</div>
                : item.status === 'inactive' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>Inactive</div>
                  : <div>{item.status}</div>
              }
            </div>
            <button onClick={() => { alert('開發中') }} className='w-[64px] h-[32px] gap-[4px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] mr-[8px]'>
              <img src='/secondary/profile.png' alt='icon' className='w-[24px]' />
              查看
            </button>
          </div>
        )}
      </div>
      <div className='font-[700]'>總數: {filter(students)?.length}</div>
      {/*end of list of students*/}











      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
